import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=6801d488"
import script from "./IncidentList.js?vue&type=script&lang=js&external"
export * from "./IncidentList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports